import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";
const { colors } = constants;

const greyBorder = `1px solid ${colors.ui.neutral[100]}`;

export const panelContainerCss: CSSObject = {
  backgroundColor: colors.ui.white[700],
  borderLeft: greyBorder,
  borderBottom: greyBorder,
  display: "flex",
  flexDirection: "column",
  height: "100%",
};

export const headerCss: CSSObject = {
  fontWeight: 700,
  fontSize: 24,
  lineHeight: "32px",
  letterSpacing: 0,
  textDecorationStyle: "solid",
  padding: 24,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",

  // The container div surrounding the Angelou button.
  // This margin bottom pushes the icon down a bit because
  // the box it was sitting in had some extra
  // whitespace at the bottom, which was preventing
  // us from centering it accurately.
  "> div": {
    marginBottom: -8,
  },
};

export const headerTitleCss: CSSObject = {
  fontWeight: 700,
  fontSize: 20,
  lineHeight: "32px",
  letterSpacing: 0,
  margin: 0,
};

export const sectionCss: CSSObject = {
  padding: "16px 24px",
  borderTop: greyBorder,
};

export const itemCss: CSSObject = {
  backgroundColor: colors.ui.core[25],
  border: `1px solid ${colors.ui.core[100]}`,
  borderRadius: 8,
  padding: "16px 12px",
  color: colors.ui.black[100],
  width: "100%",
  lineHeight: "20px",

  ":hover": {
    backgroundColor: colors.ui.core[25],
  },
};

export const iconCss: CSSObject = {
  width: 24,
  height: 24,
};

export const itemIconCss: CSSObject = {
  width: 60,
};
